import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import Protocol from "./components/Protocol";
import BtcPriceDisplay from "./components/BtcPriceDisplay";
import About from "./components/About";

function Navigation() {
  return (
    <nav className="main-nav">
      <Link to="/" className="nav-link">Home</Link>
      <Link to="/about" className="nav-link">About</Link>
      <Link to="/protocol/v0.2" className="nav-link">Protocol</Link>
    </nav>
  );
}

function Home() {
  useEffect(() => {
    document.title = "wCross Protocol";
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <Navigation />
        <h1>Crypto Native, Always.</h1>
        <p className="tagline">
          Cross-Chain Anchoring, Transparent Reserves, Secure Circulation — The Trustchain of Value Interoperability.
        </p>
        <div className="bottom-links">
          <h2>wCross Protocol</h2>
          <BtcPriceDisplay />
          <Link to="/protocol/v0.2" className="protocol-link">Protocol</Link>
        </div>
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/protocol/v0.1" element={<Protocol version="v0.1" />} />
        <Route path="/protocol/v0.2" element={<Protocol version="v0.2" />} />
        <Route path="/protocol" element={<Protocol version="v0.2" />} />
      </Routes>
    </Router>
  );
}

export default App;
